export const API_ORIGIN_TEST_SERVER = 'http://localhost:4224';
export const API_PATHNAME_TEST_SERVER = '/gateway/api/post-office/api/v1/placements/';

export const API_ORIGIN_LOCAL = 'http://localhost:8081';
export const API_PATHNAME_LOCAL = '/api/v1/placements/';
export const API_PATHNAME_STG_PROD = '/gateway/api/post-office/api/v1/placements/';

export const REMOTE_MODULE_URI_LOCAL = 'http://localhost:9009';
export const REMOTE_MODULE_URI_STG =
	'https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net';
export const REMOTE_MODULE_URI_PROD =
	'https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net';
export const REMOTE_MODULE_URI_STG_FEDM =
	'https://post-office-rml-frontend.stg.frontend.cdn.atlassian-us-gov-mod.com';
export const REMOTE_MODULE_URI_PROD_FEDM =
	'https://post-office-rml-frontend.frontend.cdn.atlassian-us-gov-mod.com';
